export default __webpack_public_path__ + "static/media/check.ee0446ef.svg";